/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { SqlVulnerabilityAssessments } from "../operationsInterfaces";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers";
import * as Parameters from "../models/parameters";
import { SqlManagementClient } from "../sqlManagementClient";
import {
  VulnerabilityAssessmentName,
  SqlVulnerabilityAssessmentsDeleteOptionalParams
} from "../models";

/** Class containing SqlVulnerabilityAssessments operations. */
export class SqlVulnerabilityAssessmentsImpl
  implements SqlVulnerabilityAssessments {
  private readonly client: SqlManagementClient;

  /**
   * Initialize a new instance of the class SqlVulnerabilityAssessments class.
   * @param client Reference to the service client
   */
  constructor(client: SqlManagementClient) {
    this.client = client;
  }

  /**
   * Removes SQL Vulnerability Assessment.
   * @param resourceGroupName The name of the resource group that contains the resource. You can obtain
   *                          this value from the Azure Resource Manager API or the portal.
   * @param serverName The name of the server.
   * @param vulnerabilityAssessmentName The name of the SQL Vulnerability Assessment.
   * @param options The options parameters.
   */
  delete(
    resourceGroupName: string,
    serverName: string,
    vulnerabilityAssessmentName: VulnerabilityAssessmentName,
    options?: SqlVulnerabilityAssessmentsDeleteOptionalParams
  ): Promise<void> {
    return this.client.sendOperationRequest(
      { resourceGroupName, serverName, vulnerabilityAssessmentName, options },
      deleteOperationSpec
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const deleteOperationSpec: coreClient.OperationSpec = {
  path:
    "/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.Sql/servers/{serverName}/sqlVulnerabilityAssessments/{vulnerabilityAssessmentName}",
  httpMethod: "DELETE",
  responses: { 200: {}, 204: {}, default: {} },
  queryParameters: [Parameters.apiVersion4],
  urlParameters: [
    Parameters.$host,
    Parameters.subscriptionId,
    Parameters.resourceGroupName,
    Parameters.serverName,
    Parameters.vulnerabilityAssessmentName
  ],
  serializer
};
